export const tabValues = {
  CLINIC_MEMBERS: 'Clinic members',
  SERVICE_TYPES: 'Service types',
  INTAKE_FORMS: 'Intake forms',
  STATES: 'States',
}

export const searchParamsKeys = {
  ACTIVE_TAB: 'activeTab',
  SEARCH_VALUE: 'searchValue',
  STATE: 'StateCodes',
  VISIT_TYPES: 'VisitTypeIds',
  STATUS: 'Status',
  SORT: 'SortOrder',
  IS_DOCTOR: 'IsDoctor',
  IS_ADMIN: 'IsAdmin',
  IS_ACTIVE: 'IsActive',
  IS_VERIFIED: 'IsVerified',
}
